export default {
  imgTtile1: `Fortune 500 Audited High Performance Electric Bicycle Manufacturer`,
  imgTtile2: `Max. 2000 Sets Output Electric Bikes`,
  imgTtile3: `Assured Lower Than 0.5% Ebike Defective Rate`,
  btnText1: `View More`,
  bannerBottomPart1Title: "Fortune 500 Audited Manufacturer",
  bannerBottomPart1Content: "MIDONKEY has been providing 6 years OEM/ODM services for TOP500 brands at home and abroad. Qualification & quality you can trust us! Even if it exceeds the one-year warranty, we can provide you with the best solution according to your purchase order volume.",
  bannerBottomPart2Title: "Supports Full Customization",
  bannerBottomPart2Content: "We are well aware that customization is indispensable. MIDONKEY specialize in rapid response to detailed requests from customers and customization of small-lot products, we also offers proposals matched to the background of requests.",
  bannerBottomPart3Title: "Lower Than 0.5% Defective Rate",
  bannerBottomPart3Content: "MIDONKEY's utmost monthly output are around 2000 sets, with reliable quality, the defective rate of MIDONKEY ebike is much lower than ordinary electric bicycle, but also significantly lower than the OEM electric bike in the market.",
  abTItle: "About Us",
  abSubTile: "Fortune 500 Audited Ebike Manufacturers",
  abContent: `MIDONKEY focus on high performance electric bicycle and electric bicycle parts manufacturing for over 6 years. We are committed to providing customers with total solutions for durable and practical electric bike, covering from electric bicycle kits to the whole packed electric bikes. According to the needs of different country markets, we research and develop new practical ebike models, always ready to provide global customers with highly competitive products and services. Due to our superior quality and excellent services, we are therefore become an important business partner with Fortune 500.`,
  faTtile: "ISO 9001 Certified Factory",
  faSubTtile: "Direct Ebikes Manufacturer In China",
  faContent: "Equip with two 50 meters long semi-automatic production line with Q.C. control unit. Max. ebike monthly output can reach as many as 2000 sets.",
  ft1: "Ebike Design Department",
  ft2: "Ebike Assembly Line",
  ft3: "Ebike Assembly Line",
  ft4: "Bike Wheel Assembly Area",
  ft5: "Ebike Materials Preparation Area",
  ft6: "Ebike Assembling",
  ft7: "Semi-finished Ebikes",
  ft8: "Ebike Testing Area",
  ft9: "Ebike Packing Area",
  ft10: "Ebike Packing Area",
  ft11: "Warehouse",
  ft12: "Ebike Bulk Shipment",
  ft13: "Salt Spray Test Room",
  ft14: "Ebike Battery Assembly Line",
  ft15: "Battery Aging Test",
  oemTtile: "OEM&ODM Ebikes Since 2017",
  oemSubTtile: "Over 30 Times Successful New Ebike Develop",
  oemList1: "ALL",
  oemList2: "Electric Mountain Bike",
  oemList3: "Electric Hybrid Bike",
  oemList4: "Electric City Bike",
  oemList5: "Electric Bicycle Parts",
  odTitle: "Full Custom Ebike Within Your Budget",
  odContent: `MIDONKEY has helped hundreds of enterprises simplify their custom decisions and earn good profits. We're also serious about your privacy. All details will NOT be disclosed to the public.`,
  odConList1: "From ebike industrial design to prototype making",
  odConList2: "Custom logos, colors, paintings, packages",
  odConList3: "Custom speeds, gears, throttle styles",
  odConList4: "Ebike private labeling, Amazon dropshipping",
  odBtn: "All Custom Services",
  formTtile: "Contact Us",
  Online: "Online Chat",
  formDept: `Get in touch and let us know how we can help. Fill out the form and a member of&nbsp;our team will be in touch within one business day.`,
  formName: "Full Name",
  formEmail: "Email",
  formTel: "Tel",
  FormMsg: "Message",
  formBtn: "Send inquiry now",
  cerTitle: "Certificates & Invention Patents",
  creCen: "Hassle-free Export & Import",
  creBtn: "View All Certificates",
  fccleft: "Material Safety Data Sheet",
  fccright: "Design Patent",
  laTtitle: `What's Happening These Days`,
  laSubTtile: "Latest News On Ebike and Everything",
  title1:`2023 China International Bicycle Exhibition`,
  content1: `On May 5, 2023, the 31st China International Bicycle Exhibition was held at Shanghai New International Expo Center with`,
  title2: `MIDONKEY Ebike Team Attends Global Sources Consumer Electronics Exhibition`,
  content2: `time:2023-04-11-04-14 Address:HK Asia World-Expo Booth:2j01`,
  title3: "MIDONKEY electric bike laboratory",
  content3: `MIDONKEY electric bicycle company is devoted to providing customers with the best quality of electric bicycles. In order`,
  ltBtns: "Read More",
  ltBtn: "Subscribe",
};
